import Triggers from './Triggers'

export default Triggers
